import { userWiseRole } from '../../utils/constant'
import { setFieldUnit } from '../../utils/customFunctions'
import { dayJs, SAVE_FORMAT } from '../../utils/dayjs'
import { include, isEqual } from '../../utils/javascript'
import { tabKeys as jobsTabKeys } from '../jobs/jobs.description'

const tabKeys = {
  forgedParts: 'forgedParts',
  scrap: 'scrap',
  vehicle: 'vehicle',
  readyToSell: 'readyToSell',
  sold: 'sold',
  scrapElv: 'scrapElv',
  partRecovered: 'partRecovered',
  material: 'material',
  bale: 'bale',
  finalProduct: 'finalProduct',
  rowMaterial: 'rowMaterial',
  forgedPart: 'forgedPart',
  forging: 'forging',
  blanking: 'blanking',
  machinedMaterial: 'machinedMaterial',
  stampedParts: 'stampedParts',
  assembledParts: 'assembledParts',
  paintedParts: 'paintedParts',
  bucket: 'bucket',
  discarded: 'discarded',
  baleRecycler: 'baleRecycler',
  rowMaterialRefurbisher: 'rowMaterialRefurbisher',
  refurbisherMaterial: 'refurbisherMaterial',
  collectionCenter: 'collectionCenter',
  recyclerPurchased: 'recyclerPurchased',
  pcr: 'pcr',
  pir: 'pir',
  jumboBag: 'jumboBag',
  preCompoundPallet: 'preCompoundPallet',
  sortedPolymers: 'sortedPolymers',
  foundryReturns: 'foundryReturns',
  machineTurnings: 'machineTurnings',
  castedParts: 'castedParts',
  virginMaterialPurchase: 'virginMaterialPurchase',
  newVehicle: 'newVehicle',
  processedMaterial: 'processedMaterial',
  readyToUse: 'readyToUse',
  unpaintedParts: 'unpaintedParts',
}

const {
  scrap,
  readyToSell,
  sold,
  scrapElv,
  bucket,
  baleRecycler,
  recyclerPurchased,
  collectionCenter,
  pcr,
  pir,
  jumboBag,
  preCompoundPallet,
  sortedPolymers,
  castedParts,
  refurbisherMaterial,
  forgedPart,
  forging,
  blanking,
  machinedMaterial,
  stampedParts,
  assembledParts,
  paintedParts,
  machineTurnings,
  foundryReturns,
  virginMaterialPurchase,
  rowMaterial,
  processedMaterial,
  discarded,
  readyToUse,
  unpaintedParts,
} = tabKeys

const dummyPartsDataSource = loginUserId => {
  return {}
}

const {
  refurbisher,
  recycler,
  recyclingTechnician,
  dealer,
  dealerUser,
  dataEntry,
  superUser,
  accounts,
  finance,
  scrappingFacilityManager,
  categoryUser,
  operationsUser,
  scrappingFacilityEntryUser,
  salesUser,
  supplier,
  supplierUser,
  producer,
  procurement,
  operations,
  sales,
} = userWiseRole

const dummyInventoryDataSource = ({ roleId }) => {
  return {}
}

const recyclerInventoryPayload = {
  [recyclerPurchased]: {
    inventoryScrapType: 'VEHICLE',
    vehicleType: 'MSTI_VEHICLE',
  },
  [collectionCenter]: {
    inventoryScrapType: 'VEHICLE',
    vehicleType: 'COLLECTION_CENTER_VEHICLE',
  },
  [pcr]: {
    inventoryScrapType: 'PCR',
  },
  [pir]: {
    inventoryScrapType: 'PIR',
  },
  [bucket]: {
    inventoryScrapType: 'BUCKET',
  },
  [baleRecycler]: {
    inventoryScrapType: 'BALE',
  },
}

const dealerInventoryPayload = {
  [scrapElv]: {
    inventoryScrapType: 'VEHICLE',
  },
}

const producerInventoryPayload = {
  [unpaintedParts]: {
    inventoryScrapType: 'FORGED_PARTS',
  },
  [readyToUse]: {
    inventoryScrapType: 'FORGED_PARTS',
  },
  [discarded]: {
    inventoryScrapType: 'FORGED_PARTS',
  },
  [readyToSell]: {
    inventoryScrapType: 'NEW_VEHICLE',
  },
  [sold]: {
    inventoryScrapType: 'NEW_VEHICLE',
  },
}

const refurbisherInventoryPayload = userMaterialType => ({
  [scrap]: {
    inventoryScrapType: 'RECYCLED_SCRAP',
    bucketState: 'SORTING',
    materialType: userMaterialType,
  },
  [sortedPolymers]: {
    inventoryScrapType: 'SORTED_POLYMER',
  },
  [jumboBag]: {
    inventoryScrapType: 'JUMBO_BAG',
  },
  [virginMaterialPurchase]: {
    inventoryScrapType: 'VIRGIN_MATERIAL',
  },
  [preCompoundPallet]: {
    inventoryScrapType: 'PRE_COMPOUNDED_PELLETS',
  },
  [readyToSell]: {
    inventoryScrapType: {
      job_Plastic: 'POST_COMPOUNDED_PELLETS',
      job_Steel: 'HEAT',
      inv_CastIron: 'HEAT',
      job_Copper: 'HEAT',
      job_Aluminium: 'HEAT',
      job_Zinc: 'HEAT',
      job_Rubber: 'HEAT',
      inv_PlatinumAndPalladium: 'HEAT',
      job_UsedOil: 'HEAT',
      job_Battery: 'HEAT',
    }[userMaterialType],
  },
  [sold]: {
    inventoryScrapType: {
      job_Plastic: 'POST_COMPOUNDED_PELLETS',
      job_Steel: 'HEAT',
      inv_CastIron: 'HEAT',
      job_Copper: 'HEAT',
      job_Aluminium: 'HEAT',
      job_Zinc: 'HEAT',
      job_Rubber: 'HEAT',
      inv_PlatinumAndPalladium: 'HEAT',
      job_UsedOil: 'HEAT',
      job_Battery: 'HEAT',
    }[userMaterialType],
  },
  [castedParts]: {
    inventoryScrapType: 'CASTED_PARTS',
  },
  [refurbisherMaterial]: {
    inventoryScrapType: 'RAW_MATERIALS',
    materialType: userMaterialType,
  },
  [forgedPart]: {
    inventoryScrapType: 'FORGED_PARTS',
  },
  [forging]: {
    inventoryScrapType: 'FORGING',
  },
  [machinedMaterial]: {
    inventoryScrapType: 'MACHINING',
  },
  [stampedParts]: {
    inventoryScrapType: 'STAMPING',
  },
  [assembledParts]: {
    inventoryScrapType: 'ASSEMBLED',
  },
  [paintedParts]: {
    inventoryScrapType: 'PAINTING',
  },
  [machineTurnings]: {
    inventoryScrapType: 'MACHINE_TURNINGS',
  },
  [foundryReturns]: {
    inventoryScrapType: 'FOUNDRY',
  },
  [rowMaterial]: {
    inventoryScrapType: 'RAW_MATERIALS',
    materialType: userMaterialType,
  },
  [processedMaterial]: {
    inventoryScrapType: {
      job_Steel: 'HEAT_BILLETS',
      inv_CastIron: 'HEAT_BILLETS',
      job_Copper: 'HEAT_BILLETS',
      job_Aluminium: 'HEAT_BILLETS',
      job_Zinc: 'HEAT_BILLETS',
      job_Rubber: 'HEAT_BILLETS',
      inv_PlatinumAndPalladium: 'HEAT_BILLETS',
      job_UsedOil: 'HEAT_BILLETS',
      job_Battery: 'HEAT_BILLETS',
    }[userMaterialType],
  },
})

const supplierInventoryPayload = userMaterialType => ({
  [rowMaterial]: {
    inventoryScrapType: 'RAW_MATERIALS',
    materialType: userMaterialType,
  },
  [forgedPart]: {
    inventoryScrapType: 'FORGED_PARTS',
  },
  [forging]: {
    inventoryScrapType: 'FORGING_BATCH',
  },
  [blanking]: {
    inventoryScrapType: 'BLANKING_BATCH',
  },
  [machinedMaterial]: {
    inventoryScrapType: 'MACHINING_BATCH',
  },
  [stampedParts]: {
    inventoryScrapType: 'STAMPING_BATCH',
  },
  [assembledParts]: {
    inventoryScrapType: 'ASSEMBLY_BATCH',
  },
  [paintedParts]: {
    inventoryScrapType: 'PAINTING_BATCH',
  },
})

const inventoryPayload = userMaterialType => ({
  [recycler]: recyclerInventoryPayload,
  [scrappingFacilityManager]: recyclerInventoryPayload,
  [categoryUser]: recyclerInventoryPayload,
  [operationsUser]: recyclerInventoryPayload,
  [salesUser]: recyclerInventoryPayload,
  [scrappingFacilityEntryUser]: recyclerInventoryPayload,
  [recyclingTechnician]: recyclerInventoryPayload,
  [superUser]: recyclerInventoryPayload,
  [dataEntry]: recyclerInventoryPayload,
  [accounts]: recyclerInventoryPayload,
  [finance]: recyclerInventoryPayload,
  [dealer]: dealerInventoryPayload,
  [dealerUser]: dealerInventoryPayload,
  [refurbisher]: refurbisherInventoryPayload(userMaterialType),
  [procurement]: refurbisherInventoryPayload(userMaterialType),
  [operations]: refurbisherInventoryPayload(userMaterialType),
  [sales]: refurbisherInventoryPayload(userMaterialType),
  [supplier]: supplierInventoryPayload(userMaterialType),
  [supplierUser]: supplierInventoryPayload(userMaterialType),
  [producer]: producerInventoryPayload,
})

const addRecyclerPurchasedField = {
  rvsfVehicleNo: {
    label: 'job_RVSFVehicleNo',
    inputType: 'input',
    md: 24,
    xs: 24,
    required: true,
  },
}

const addProcessFields = {
  receiptDateChassis: {
    label: 'job_DateOfReceiptOfChassisCutOut',
    inputType: 'dateTimePicker',
    className: 'w-100',
    md: 8,
    xs: 24,
    format: SAVE_FORMAT,
  },
  receiptDateEngineNo: {
    label: 'job_DateOfReceiptOfEngineNoCutOut',
    inputType: 'dateTimePicker',
    className: 'w-100',
    md: 8,
    xs: 24,
    format: SAVE_FORMAT,
  },
  receiptDateCompliancePlate: {
    label: 'job_DateOfReceiptOfCompliancePlate',
    inputType: 'dateTimePicker',
    className: 'w-100',
    md: 8,
    xs: 24,
    format: SAVE_FORMAT,
  },
  certificateOfDepositNo: {
    label: 'job_CertificateOfDepositNo',
    inputType: 'input',
    md: 8,
    xs: 24,
  },
  certificateOfDepositDate: {
    label: 'job_CertificateOfDepositDate',
    inputType: 'dateTimePicker',
    className: 'w-100',
    md: 8,
    xs: 24,
    format: SAVE_FORMAT,
  },
  certificateOfVehicleScrappingNo: {
    label: 'job_DestructionCertificateCVSNo',
    inputType: 'input',
    md: 8,
    xs: 24,
  },
  dateOfDestructionCertificate: {
    label: 'job_DateOfDestructionCertificateCVS',
    inputType: 'dateTimePicker',
    className: 'w-100',
    md: 8,
    xs: 24,
    format: SAVE_FORMAT,
  },
  processDate: {
    label: 'job_ProcessDate',
    inputType: 'dateTimePicker',
    className: 'w-100 input-plain-text',
    md: 8,
    xs: 24,
    format: SAVE_FORMAT,
    defaultValue: dayJs(),
    disabled: true,
    variant: 'borderless',
    suffixIcon: null,
  },
}

// Vehicle Traceability Fields
//vehicle details
const getVehicleFields = (vehicleData, type) => {
  return [
    ...(isEqual(type, 'processLoss')
      ? [
          {
            translationKey: 'job_DPPId',
            value: vehicleData?.dppId,
          },
        ]
      : [
          {
            translationKey: 'inv_OEMName',
            value: vehicleData?.producer?.businessName,
          },
          {
            translationKey: 'job_ModelName',
            value: vehicleData?.vehicleModelName,
          },
          {
            translationKey: 'job_VehicleId',
            value: vehicleData?.id || vehicleData?.vehicleId,
          },
        ]),
    {
      translationKey: 'job_EngineNumber',
      value: vehicleData?.vehicleEngineNo,
    },
    {
      translationKey: 'job_ChassisNumber',
      value: vehicleData?.vehicleChassisNo,
    },
  ]
}

//part details
const getPartFields = part => {
  return [
    {
      translationKey: 'job_PartId',
      value: part?.id || '-',
      // isLink: true,
    },
    {
      translationKey: 'job_PartNumber',
      value: part?.partNumber || '-',
      // isLink: true,
    },
    {
      translationKey: 'job_RecycledMaterialPercentage',
      value: include([86260], part?.id)
        ? 73.54
        : part?.recycledMaterialUsed || part?.recyclability || 0,
    },
  ]
}

//jobs field function - handles all job types
const getJobsFields = ({ jobType, jobData, materialType, t, type }) => {
  const processLossValue = jobData?.outputScrapDtos?.[0]?.processLoss || 0
  const processLossField = isEqual(type, 'processLoss')
    ? [
        {
          translationKey: setFieldUnit({
            t,
            fieldName: 'job_ProcessLoss',
          }),
          value: processLossValue ? processLossValue?.toFixed(2) : 0,
        },
      ]
    : []
  const fieldsMap = {
    // Part Sales (Part Producer)
    PART_SALES_PART_PRODUCER: [
      {
        translationKey: 'job_InvoiceId',
        value: jobData?.invoiceId || jobData?.invoiceNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobData?.jobType,
      },
      {
        translationKey: 'job_DispatchDate',
        value: jobData?.jobCompletionDate || '-',
      },
      {
        translationKey: 'job_SupplierName',
        value: jobData?.partProducerInfo?.businessName || '-',
      },
      {
        translationKey: 'job_PartBatchId',
        value: jobData?.outputScrapDtos?.[0]?.batchNumber || '-',
      },
      {
        translationKey: 'job_RecycledMaterialPercentage',
        value: include([31195], jobData?.id)
          ? 73.54
          : jobData?.outputScrapDtos?.[0]?.recycledMaterialUsed ||
            jobData?.outputScrapDtos?.[0]?.recyclability ||
            0,
      },
    ],

    // Part Production (Supplier Production)
    PART_PRODUCTION: [
      {
        translationKey: 'job_PartBatchId',
        value: jobData?.outputScrapDtos?.[0]?.batchNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobData?.jobType,
      },
      {
        translationKey: 'job_PartName',
        value: jobData?.outputScrapDtos?.[0]?.typeOfProductKey
          ? t(jobData?.outputScrapDtos?.[0]?.typeOfProductKey)
          : '-',
      },
      {
        translationKey: 'job_SupplierName',
        value: jobData?.partProducerInfo?.businessName || '-',
      },
      ...processLossField,
    ],

    // Material Sales (Part Producer)
    MATERIAL_SALES_PART_PRODUCER: [
      {
        translationKey: 'job_InvoiceId',
        value: jobData?.invoiceId || jobData?.invoiceNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobData?.jobType,
      },
      {
        translationKey: 'job_DispatchDate',
        value: jobData?.jobCompletionDate || '-',
      },
      {
        translationKey: 'user_RefurbisherName',
        value: jobData?.materialProducerInfo?.businessName || '-',
      },
      {
        translationKey:
          materialType === 'job_Plastic'
            ? 'job_CompoundingBatchID'
            : 'job_PostProcessingHeatID',
        value: jobData?.outputScrapDtos?.[0]?.userEnteredBatchNumber || '-',
      },
      {
        translationKey: 'job_RecycledMaterialPercentage',
        value: include([31193], jobData?.id)
          ? 73.54
          : jobData?.outputScrapDtos?.[0]?.recycledMaterialUsed ||
            jobData?.outputScrapDtos?.[0]?.recyclability ||
            0,
      },
      {
        translationKey: setFieldUnit({ t, fieldName: 'job_QuantitySold' }),
        value: jobData?.outputScrapDtos?.[0]?.quantityUsed || '-',
      },
    ],
    // Post Processing
    POST_PROCESSING: [
      {
        translationKey: 'job_PostProcessingHeatID',
        value: jobData?.userEnteredBatchNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobData?.jobType,
      },
      {
        translationKey: 'user_RefurbisherName',
        value: jobData?.materialProducerInfo?.businessName || '-',
      },
      {
        translationKey: 'job_RecycledMaterialPercentage',
        value: include([31186], jobData?.id)
          ? 73.54
          : jobData?.outputScrapDtos?.[0]?.recycledMaterialUsed ||
            jobData?.outputScrapDtos?.[0]?.recyclability ||
            0,
      },
      {
        translationKey: 'job_TypeOfProduct',
        value: jobData?.outputScrapDtos?.[0]?.productType || '-',
      },
      {
        translationKey: 'job_TotalWeightKgs',
        value: jobData?.outputScrapDtos?.[0]?.quantityUsed || '-',
      },
      ...processLossField,
    ],
    // Forging
    FORGING: [
      {
        translationKey: 'job_BatchId',
        value: jobData?.outputScrapDtos?.[0]?.batchNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobsTabKeys.forging,
      },
      {
        translationKey: 'job_SupplierName',
        value:
          jobData?.partProducerInfo?.businessName ||
          jobData?.materialProducerInfo?.businessName ||
          '-',
      },
      {
        translationKey: 'job_PartNumber',
        value: jobData?.outputScrapDtos?.[0]?.partNumber || '-',
      },
      {
        translationKey: 'job_RecycledMaterialPercentage',
        value:
          jobData?.outputScrapDtos?.[0]?.recycledMaterialUsed ||
          jobData?.outputScrapDtos?.[0]?.recyclability ||
          0,
      },
      ...processLossField,
    ],
    // Blanking
    BLANKING: [
      {
        translationKey: 'job_OutputBatchNumber',
        value: jobData?.outputScrapDtos?.[0]?.batchNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobsTabKeys.blanking,
      },
      {
        translationKey: 'job_SupplierName',
        value:
          jobData?.partProducerInfo?.businessName ||
          jobData?.materialProducerInfo?.businessName ||
          '-',
      },
      {
        translationKey: 'job_PartNumber',
        value: jobData?.outputScrapDtos?.[0]?.partNumber || '-',
      },
      {
        translationKey: 'job_RecycledMaterialPercentage',
        value:
          jobData?.outputScrapDtos?.[0]?.recycledMaterialUsed ||
          jobData?.outputScrapDtos?.[0]?.recyclability ||
          0,
      },
      ...processLossField,
    ],
    // Machining
    MACHINING: [
      {
        translationKey: 'job_MachiningBatchNumber',
        value: jobData?.outputScrapDtos?.[0]?.batchNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobsTabKeys.machining,
      },
      {
        translationKey: 'job_SupplierName',
        value:
          jobData?.partProducerInfo?.businessName ||
          jobData?.materialProducerInfo?.businessName ||
          '-',
      },
      {
        translationKey: 'job_PartNumber',
        value: jobData?.outputScrapDtos?.[0]?.partNumber || '-',
      },
      {
        translationKey: 'job_RecycledMaterialPercentage',
        value:
          jobData?.outputScrapDtos?.[0]?.recycledMaterialUsed ||
          jobData?.outputScrapDtos?.[0]?.recyclability ||
          0,
      },
      ...processLossField,
    ],
    STAMPING: [
      {
        translationKey: 'job_StampingBatchNumber',
        value: jobData?.outputScrapDtos?.[0]?.batchNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobsTabKeys.stamping,
      },
      {
        translationKey: 'job_SupplierName',
        value:
          jobData?.partProducerInfo?.businessName ||
          jobData?.materialProducerInfo?.businessName ||
          '-',
      },
      {
        translationKey: 'job_PartNumber',
        value: jobData?.outputScrapDtos?.[0]?.partNumber || '-',
      },
      {
        translationKey: 'job_RecycledMaterialPercentage',
        value:
          jobData?.outputScrapDtos?.[0]?.recycledMaterialUsed ||
          jobData?.outputScrapDtos?.[0]?.recyclability ||
          0,
      },
      ...processLossField,
    ],
    // Assembly
    ASSEMBLY: [
      {
        translationKey: 'job_AssemblyBatchNumber',
        value: jobData?.outputScrapDtos?.[0]?.batchNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobsTabKeys.assembly,
      },
      {
        translationKey: 'job_SupplierName',
        value:
          jobData?.partProducerInfo?.businessName ||
          jobData?.materialProducerInfo?.businessName ||
          '-',
      },
      {
        translationKey: 'job_PartNumber',
        value: jobData?.outputScrapDtos?.[0]?.partNumber || '-',
      },
      {
        translationKey: 'job_RecycledMaterialPercentage',
        value:
          jobData?.outputScrapDtos?.[0]?.recycledMaterialUsed ||
          jobData?.outputScrapDtos?.[0]?.recyclability ||
          0,
      },
      ...processLossField,
    ],
    PAINTING: [
      {
        translationKey: 'job_PaintingBatchNumber',
        value: jobData?.outputScrapDtos?.[0]?.batchNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobsTabKeys.painting,
      },
      {
        translationKey: 'job_SupplierName',
        value:
          jobData?.partProducerInfo?.businessName ||
          jobData?.materialProducerInfo?.businessName ||
          '-',
      },
      {
        translationKey: 'job_PartNumber',
        value: jobData?.outputScrapDtos?.[0]?.partNumber || '-',
      },
      {
        translationKey: 'job_RecycledMaterialPercentage',
        value:
          jobData?.outputScrapDtos?.[0]?.recycledMaterialUsed ||
          jobData?.outputScrapDtos?.[0]?.recyclability ||
          0,
      },
      ...processLossField,
    ],
    // Material Production
    MATERIAL_PRODUCTION: [
      {
        translationKey: 'job_MaterialProductionHeatID',
        value: jobData?.outputScrapDtos?.[0]?.userEnteredBatchNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobData?.jobType,
      },
      {
        translationKey: 'user_RefurbisherName',
        value: jobData?.materialProducerInfo?.businessName || '-',
      },
      {
        translationKey: 'job_RecycledMaterialPercentage',
        value: include([31185], jobData?.id)
          ? 73.54
          : jobData?.outputScrapDtos?.[0]?.recycledMaterialUsed ||
            jobData?.outputScrapDtos?.[0]?.recyclability ||
            0,
      },
      {
        translationKey: 'job_TypeOfProduct',
        value: jobData?.outputScrapDtos?.[0]?.productType || '-',
      },
      {
        translationKey: 'job_TotalWeightKgs',
        value: jobData?.outputScrapDtos?.[0]?.quantityUsed || '-',
      },
      ...processLossField,
    ],
    // Dispatch(Recycle) Request
    RECYCLE: [
      {
        translationKey: 'job_InvoiceId',
        value: jobData?.invoiceId || jobData?.invoiceNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobData?.jobType,
      },
      {
        translationKey: 'job_DispatchDate',
        value: jobData?.jobCompletionDate || '-',
      },
    ],
    // RECOVERY
    RECOVERY: [
      {
        translationKey: 'inv_ScrappingFacilityName',
        value: jobData?.recyclerInfo?.businessName || '-',
      },
      {
        translationKey: 'job_RVSFVehicleNumber',
        value: jobData?.outputScrapDtos?.[0]?.mstiVehicleNo || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobData?.jobType,
      },
      {
        translationKey: 'job_VehicleRegistrationNumber',
        value: jobData?.outputScrapDtos?.[0]?.vehicleRegistrationNumber || '-',
      },
      {
        translationKey: 'job_EngineNumber',
        value: jobData?.outputScrapDtos?.[0]?.vehicleEngineNo || '-',
      },
      {
        translationKey: 'job_ChassisNumber',
        value: jobData?.outputScrapDtos?.[0]?.vehicleChassisNo || '-',
      },
      ...processLossField,
    ],
    // Compounding Pelletization
    COMPOUNDING_PELLETIZING: [
      {
        translationKey: 'job_CompoundingBatchID',
        value: jobData?.outputScrapDtos?.[0]?.userEnteredBatchNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobData?.jobType,
      },
      {
        translationKey: 'user_RefurbisherName',
        value: jobData?.materialProducerInfo?.businessName || '-',
      },
      {
        translationKey: 'job_RecycledMaterialPercentage',
        value:
          jobData?.outputScrapDtos?.[0]?.recycledMaterialUsed ||
          jobData?.outputScrapDtos?.[0]?.recyclability ||
          0,
      },
      {
        translationKey: 'job_TotalWeightKgs',
        value: jobData?.outputScrapDtos?.[0]?.quantityUsed || '-',
      },
      ...processLossField,
    ],
    // Material Sales (Material Producer)
    MATERIAL_SALES_MATERIAL_PRODUCER: [
      {
        translationKey: 'job_InvoiceId',
        value: jobData?.invoiceId || jobData?.invoiceNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobData?.jobType,
      },
      {
        translationKey: 'job_DispatchDate',
        value: jobData?.jobCompletionDate || '-',
      },
      {
        translationKey: 'user_RefurbisherName',
        value:
          jobData?.materialProducerInfo?.businessName ||
          jobData?.materialProducerName ||
          '-',
      },
      {
        translationKey: 'inv_BatchId',
        value: jobData?.outputScrapDtos?.[0]?.userEnteredBatchNumber || '-',
      },
      {
        translationKey: 'job_RecycledMaterialPercentage',
        value:
          jobData?.outputScrapDtos?.[0]?.recycledMaterialUsed ||
          jobData?.outputScrapDtos?.[0]?.recyclability ||
          0,
      },
      {
        translationKey: setFieldUnit({ t, fieldName: 'job_QuantitySold' }),
        value: jobData?.outputScrapDtos[0]?.quantityUsed || '-',
      },
    ],
    // Pre Compounding Pelletization
    PRE_COMPOUNDING_PELLETIZING: [
      {
        translationKey: 'job_PreCompoundingBatchId',
        value: jobData?.outputScrapDtos?.[0]?.userEnteredBatchNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobData?.jobType,
      },
      {
        translationKey: 'user_RefurbisherName',
        value:
          jobData?.materialProducerInfo?.businessName ||
          jobData?.materialProducerName ||
          '-',
      },
      {
        translationKey: 'job_TotalWeightKgs',
        value: jobData?.outputScrapDtos?.[0]?.quantityUsed || '-',
      },
      ...processLossField,
    ],
    // Grinding
    GRINDING: [
      {
        translationKey: 'job_GrindingBatchId',
        value: jobData?.outputScrapDtos?.[0]?.userEnteredBatchNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobData?.jobType,
      },
      {
        translationKey: 'user_RefurbisherName',
        value:
          jobData?.materialProducerInfo?.businessName ||
          jobData?.materialProducerName ||
          '-',
      },
      {
        translationKey: 'job_TotalWeightKgs',
        value: jobData?.outputScrapDtos?.[0]?.quantityUsed || '-',
      },
      ...processLossField,
    ],
    // Sorting
    SORTING: [
      {
        translationKey: 'job_SortingBatchId',
        value: jobData?.outputScrapDtos?.[0]?.userEnteredBatchNumber || '-',
        isLink: true,
        jobId: jobData?.jobId,
        jobType: jobData?.jobType,
      },
      {
        translationKey: 'user_RefurbisherName',
        value:
          jobData?.materialProducerInfo?.businessName ||
          jobData?.materialProducerName ||
          '-',
      },
      {
        translationKey: 'job_TotalWeightKgs',
        value: jobData?.outputScrapDtos?.[0]?.quantityUsed || '-',
      },
      ...processLossField,
    ],
  }

  // Return fields for the specified job type, or empty array if not found
  return fieldsMap[jobType] || []
}

const steelItems = [
  'ASSEMBLY',
  'PAINTING',
  'MACHINING',
  'STAMPING',
  'FORGING',
  'BLANKING',
  'MATERIAL_SALES_PART_PRODUCER',
  'POST_PROCESSING',
  'MATERIAL_PRODUCTION',
  'RECYCLE',
  'RECOVERY',
]

const plasticItems = [
  'COMPOUNDING_PELLETIZING',
  'MATERIAL_SALES_MATERIAL_PRODUCER',
  'PRE_COMPOUNDING_PELLETIZING',
  'GRINDING',
  'SORTING',
  'RECYCLE',
  'RECOVERY',
]

const traceabilityJobTitles = {
  PART_SALES_PRODUCER: 'job_PartSalesProducer',
  PART_PRODUCTION: 'job_SupplierProductionJob',
  MATERIAL_SALES_PART_PRODUCER: 'job_MaterialSalesSupplier',
  ASSEMBLY: 'job_AssemblyJob',
  PAINTING: 'job_PaintingJob',
  MACHINING: 'job_MachiningJob',
  STAMPING: 'job_StampingJob',
  FORGING: 'job_ForgingJob',
  BLANKING: 'job_BlankingJob',
  COMPOUNDING_PELLETIZING: 'job_CompoundingPelletizingJob',
  MATERIAL_SALES_MATERIAL_PRODUCER: 'job_MaterialSalesMaterialProducer',
  PRE_COMPOUNDING_PELLETIZING: 'job_PreCompoundingPelletizingJob',
  GRINDING: 'job_GrindingJob',
  SORTING: 'job_SortingJob',
  POST_PROCESSING: 'job_PostMaterialProduction',
  MATERIAL_PRODUCTION: 'job_RefurbishmentJob',
  RECYCLE: 'home_RecycleRequest',
  RECOVERY: 'job_ELV',
}

const getForgedPartTypeParams = ({ partKey, tabKey }) =>
  isEqual(partKey, 'Door Parts')
    ? {
        partType: isEqual(tabKey, tabKeys.unpaintedParts)
          ? 'UN_PAINTED'
          : 'PAINTED',
      }
    : {}

const getTraceabilityFieldsJobType = jobType =>
  jobType === 'PART_SALES_PRODUCER' ? 'PART_SALES_PART_PRODUCER' : jobType

export {
  getForgedPartTypeParams,
  addProcessFields,
  addRecyclerPurchasedField,
  dummyInventoryDataSource,
  dummyPartsDataSource,
  inventoryPayload,
  tabKeys,
  getVehicleFields,
  getPartFields,
  getJobsFields,
  steelItems,
  plasticItems,
  traceabilityJobTitles,
  getTraceabilityFieldsJobType,
}
